/**
 * @fileoverview Agent definition for scene-explorer-v1.
 *
 * This agent analyzes prose and proposes 4 distinct visual composition
 * approaches, letting the user choose how a scene should be framed
 * before generating a full image prompt.
 *
 * @category visuals.prompts.story
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'scene-explorer-v1',
  kind: 'primitive',
  name: 'Scene Explorer',
  description: 'Analyzes prose and proposes 4 distinct visual composition approaches for the scene.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'visuals.prompts.story',
    usedBy: [
      'use-explore-scenes.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'scene-prompt-creator-v1',
      'story-image-prompt-creator-v2',
    ],
  },
};
